import React from 'react';
import Color from 'color';

// import '../style/Tag.scss';
const Tag = ({ children, color }) => {
  let colorObj = Color(color);
  return (
    <div
      className={`Tag ${colorObj.luminosity() < 0.5 ? 'dark' : 'light'}`}
      style={{ backgroundColor: color }}
    >
      {children}
    </div>
  );
};

export default Tag;
